import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'small' | 'normal' | 'large';
}

export default function ComicCard({ comic, size = 'normal' }: ComicCardProps) {
  const sizeClasses = {
    small: 'w-[140px] sm:w-[160px]',
    normal: 'w-[160px] sm:w-[180px]',
    large: 'w-[180px] sm:w-[200px]',
  };

  return (
    <Link
      to={`/comic/${comic.id}`}
      className={`${sizeClasses[size]} group block cursor-pointer`}
    >
      <div className="relative overflow-hidden rounded-lg mb-2.5 aspect-[3/4]">
        <img
          src={comic.cover}
          alt={`${comic.title} - 女神漫画`}
          title={`${comic.title} - 女神漫画免费在线阅读`}
          className="w-full h-full object-cover object-top transition-transform duration-400 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        {comic.status === 'ongoing' && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-xs font-medium rounded-full bg-accent-500 text-background-50 whitespace-nowrap">
            连载
          </span>
        )}
        {comic.status === 'completed' && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-xs font-medium rounded-full bg-secondary-600 text-background-50 whitespace-nowrap">
            完结
          </span>
        )}
        {comic.isNew && (
          <span className="absolute top-2 right-2 px-2 py-0.5 text-xs font-medium rounded-full bg-primary-500 text-background-50 whitespace-nowrap">
            NEW
          </span>
        )}
        <div className="absolute bottom-0 left-0 right-0 p-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="text-xs text-background-50 line-clamp-1">{comic.description}</span>
        </div>
      </div>
      <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
        {comic.title}
      </h3>
      <div className="flex items-center justify-between mt-1">
        <span className="text-xs text-foreground-500">{comic.author}</span>
        <span className="flex items-center gap-0.5 text-xs text-primary-500">
          <i className="ri-star-fill text-[10px]"></i>
          {comic.rating}
        </span>
      </div>
    </Link>
  );
}